module.exports = __webpack_public_path__ + "static/media/user-outline.ac98f6d4.svg";